import React from 'react';
import { MODALS } from '../../../../config/images';
const ModalAlertPercente = ({ showModalAlertPercente, closeModal}) => {
  if (!showModalAlertPercente) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[30%] w-[85%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4  ">
        <div className='flex justify-end'>
          <button
            onClick={closeModal}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>
        <div className='flex flex-row items-start justify-center gap-3 px-8 pb-3'>
            <img src={MODALS.WARNING} alt="warning"/>
            <div className='flex flex-col'>
              <p className="lg:text-[1vw] font-itcdemi">
              No puedes registrar este porcentaje. Debes elegir un porcentaje ya existente.
              </p>
            </div>
        </div>
      </div>
    </div>
  );
};
export default ModalAlertPercente;
